import React from "react";
import { Table, Tag, Space } from "antd";

const UserTable = ({
  filteredLogs,
  loading,
  pageC,
  setPageC,
  limit,
  setLimit,
  totalLogs
}) => {
  const columns = [
    {
      title: "Timestamp",
      dataIndex: "createdAt",
      key: "createdAt",
      render: (text) => (text ? new Date(text).toLocaleString() : "-"),
    },
    {
      title: "User",
      key: "user",
      render: (_, record) => {
        const userObj = record?.user;
        const email = userObj?.email || record?.userEmail || userObj?.name || record?.userName || "-";
        const roleName = userObj?.role?.name || record?.role || record?.userRole;

        return (
          <Space  size={2}>
            <Tag color="geekblue">{email}</Tag>
            {roleName ? <Tag color="green">{roleName}</Tag> : null}
          </Space>
        );
      },
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (text) => <Tag color="blue">{text || "-"}</Tag>,
    },
    {
      title: "Entity",
      key: "entity",
      render: (_, r) => (r?.entity ? <Tag>{r.entity}</Tag> : "-"),
    },
    {
      title: "IP",
      dataIndex: "ip",
      key: "ip",
      render: (text) => text || "-",
    },
    {
      title: "Message",
      dataIndex: "message",
      key: "message",
      render: (text) => text || "-",
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={filteredLogs}
      rowKey={(r) => r._id || `${r.createdAt}-${r.userEmail}-${r.action}`}
      pagination={{
        current: pageC,
        total: totalLogs,
        pageSize: limit,
        onChange: (page, pageSize) => {
          if (pageSize !== limit) {
            setLimit(pageSize);
            setPageC(1);
          } else {
            setPageC(page);
          }
        },
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total, range) =>
          `${range[0]}-${range[1]} of ${total} logs`,
      }}
      bordered
      size="middle"
      scroll={{ x: 1000 }}
      loading={loading}
      locale={{
        emptyText: filteredLogs.length === 0
          ? "No logs found"
          : "No logs match your search criteria"
      }}
    />
  );
};

export default UserTable;
